import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import cardStyles from "@/components/general/card/card.module.css";

import styles from "./interaction-instructions.module.css";
import { Key } from "./key";
import { Mouse } from "./mouse";
export const InteractionInstructions = () => {
    const { t } = useTranslation();
    return (
        <Box className={`${cardStyles.card} ${styles.interactionInstructions}`}>
            <div className={styles.keyboard}>
                <div className={styles.wasd}>
                    <Key keyType="w" className={styles.w} />
                    <Key keyType="a" className={styles.a} />
                    <Key keyType="s" className={styles.s} label={t("details.explanation.move")} />
                    <Key keyType="d" className={styles.d} />
                </div>

                <div className={styles.actions}>
                    <Key keyType="e" label={t("details.explanation.inspect")} />
                    <Key keyType="q" label={t("details.explanation.drop")} />
                    <Key keyType="numbers" label={t("details.explanation.inventory")} />
                    <Key keyType="z" label={t("details.explanation.zoom")} />
                    <Key keyType="m" label={t("details.explanation.menu")} />
                    <Key keyType="space" label={t("details.explanation.jump")} className={styles.space} />
                </div>
            </div>

            <div className={styles.mouse}>
                <Mouse type="move" label={t("details.explanation.look")} width={144} />
                <Mouse type="left" label={t("details.explanation.left")} />
                <Mouse type="right" label={t("details.explanation.right")} />
                <Mouse type="wheel" label={t("details.explanation.mousewheel")} />
            </div>
        </Box>
    );
};
